import { render, staticRenderFns } from "./PaymentPix.vue?vue&type=template&id=c9514948&scoped=true"
import script from "./PaymentPix.vue?vue&type=script&lang=js"
export * from "./PaymentPix.vue?vue&type=script&lang=js"
import style0 from "./PaymentPix.vue?vue&type=style&index=0&id=c9514948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9514948",
  null
  
)

export default component.exports